import React from "react";
import Navbar from "@/components/Navbar";
import NewHome from "@/components/NewHome";
import Footer from "@/components/Footer";
import { PropertyCorrectionsProvider } from "@/contexts/PropertyCorrectionsContext";

const NewHomePage = () => {
  return (
    <PropertyCorrectionsProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <NewHome />
        </main>
        <Footer />
      </div>
    </PropertyCorrectionsProvider>
  );
};

export default NewHomePage;
